import { render, staticRenderFns } from "./input-currency.vue?vue&type=template&id=0d6afbce"
import script from "./input-currency.vue?vue&type=script&lang=js"
export * from "./input-currency.vue?vue&type=script&lang=js"
import style0 from "./input-currency.vue?vue&type=style&index=0&id=0d6afbce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports